import React, { useState, useEffect } from 'react';
import '../App.css';

function ScheduleManager() {
  const [schedules, setSchedules] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(1);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');

  const monthNames = ['', 'January', 'February', 'March', 'April', 'May', 'June',
                     'July', 'August', 'September', 'October', 'November', 'December'];

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    try {
      setLoading(true);
      const res = await fetch('https://storypublisher.onrender.com/schedules');
      const data = await res.json();
      setSchedules(data);
    } catch (err) {
      console.error('Error loading schedules:', err);
      setMessage('Error loading schedules');
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      setMessage('Uploading...');

      const formData = new FormData();
      formData.append('image', file);
      formData.append('month', selectedMonth);

      const res = await fetch('https://storypublisher.onrender.com/schedules', {
        method: 'POST',
        body: formData
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(`❌ ${data.error || 'Upload failed'}`);
        return;
      }

      setMessage('✅ Schedule updated successfully');
      e.target.value = '';
      fetchSchedules();
    } catch (err) {
      console.error('Error uploading:', err);
      setMessage('❌ Upload error');
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteSchedule = async (month) => {
    if (!window.confirm(`Delete ${monthNames[month]} schedule?`)) {
      return;
    }

    try {
      setUploading(true);
      setMessage('Deleting...');

      const res = await fetch(`https://storypublisher.onrender.com/schedules/${month}`, {
        method: 'DELETE',
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(`❌ ${data.error || 'Delete failed'}`);
        return;
      }

      setMessage('✅ Schedule deleted');
      fetchSchedules();
    } catch (err) {
      console.error('Error deleting:', err);
      setMessage('❌ Delete error');
    } finally {
      setUploading(false);
    }
  };

  const currentSchedule = schedules.find(s => s.month === selectedMonth);

  return (
    <div style={{ padding: '20px', border: '2px solid #FF9800', borderRadius: '8px', marginBottom: '20px' }}>
      <h2>📅 Manage Monthly Schedules</h2>

      {/* Month selector */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
          Select Month:
        </label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          {monthNames.slice(1).map((name, idx) => {
            const month = idx + 1;
            return (
              <button
                key={month}
                onClick={() => setSelectedMonth(month)}
                style={{
                  padding: '8px 12px',
                  backgroundColor: selectedMonth === month ? '#4CAF50' : '#2196F3',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: selectedMonth === month ? 'bold' : 'normal',
                }}
                disabled={uploading}
              >
                {name.substring(0, 3)}
              </button>
            );
          })}
        </div>
      </div>

      {/* Current schedule display */}
      {currentSchedule && currentSchedule.imagePath && (
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#666' }}>Current Schedule for {monthNames[selectedMonth]}:</p>
          <img
            src={currentSchedule.imagePath}
            alt={`${monthNames[selectedMonth]} Schedule`}
            style={{ maxWidth: '100%', maxHeight: '300px', borderRadius: '4px', marginBottom: '10px' }}
          />
          <br />
          <button
            onClick={() => handleDeleteSchedule(selectedMonth)}
            disabled={uploading}
            style={{
              padding: '8px 16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: uploading ? 'not-allowed' : 'pointer',
              marginBottom: '15px',
              opacity: uploading ? 0.6 : 1,
            }}
          >
            Delete This Schedule
          </button>
        </div>
      )}

      {/* Upload section */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
          {currentSchedule && currentSchedule.imagePath ? '📝 Replace Schedule Image:' : '📤 Upload Schedule Image:'}
        </label>
        <input
          type="file"
          accept="image/*"
          onChange={handleFileUpload}
          disabled={uploading}
          style={{
            padding: '10px',
            border: '2px dashed #2196F3',
            borderRadius: '4px',
            width: '100%',
            cursor: uploading ? 'not-allowed' : 'pointer',
            opacity: uploading ? 0.6 : 1,
          }}
        />
      </div>

      {/* Message display */}
      {message && (
        <div style={{
          padding: '10px',
          backgroundColor: message.includes('✅') ? '#c8e6c9' : '#ffcdd2',
          color: message.includes('✅') ? '#2e7d32' : '#c62828',
          borderRadius: '4px',
          marginTop: '10px',
          textAlign: 'center',
        }}>
          {message}
        </div>
      )}
    </div>
  );
}

export default ScheduleManager;
